function readTimestampMs(value) {
  if (!value) return 0;
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? 0 : ms;
}

/**
 * Agrupa fotos do painel (abastecimento + assumir máquina) para exibição por máquina.
 */
export function collectMachinePanelPhotos(fieldEvents, fuelRecords, panelPhotos) {
  const seen = new Set();
  const items = [];

  const pushItem = (item) => {
    const key = item.url || `${item.source}-${item.timestamp}-${item.label}`;
    if (seen.has(key)) return;
    seen.add(key);
    items.push(item);
  };

  (panelPhotos || []).forEach((photo) => {
    if (!photo || !photo.panelPhotoUrl) return;
    pushItem({
      url: photo.panelPhotoUrl,
      timestamp: photo.timestamp,
      label: photo.label || "Foto do painel",
      operatorName: photo.operatorName || "",
      source: photo.type || "photo",
    });
  });

  (fieldEvents || []).forEach((event) => {
    if (!event || !event.panelPhotoUrl) return;
    pushItem({
      url: event.panelPhotoUrl,
      timestamp: event.timestamp,
      label: event.label || event.type || "Evento",
      operatorName: event.operatorName || "",
      source: event.type || "event",
      hourMeter: event.hourMeter,
      liters: event.liters,
    });
  });

  (fuelRecords || []).forEach((record) => {
    const url = record.panelPhotoUrl;
    if (!url) return;
    pushItem({
      url,
      timestamp: record.timestamp,
      label: "Abastecimento",
      operatorName: record.operatorName || "",
      source: "fueling",
      hourMeter: record.hourMeter != null ? record.hourMeter : record.hour_meter,
      liters: record.liters,
    });
  });

  return items.sort(
    (a, b) => readTimestampMs(b.timestamp) - readTimestampMs(a.timestamp)
  );
}
